import { Node } from "@xyflow/react";
import { atom } from "jotai";

import { DefaultNodeData } from "../types";

import { nodesAtom } from "./nodesAtom";

export const defaultNodesAtom = atom<Node<DefaultNodeData>[]>(
  (get) =>
    get(nodesAtom).filter(
      (node) => node.type === "default",
    ) as Node<DefaultNodeData>[],
);

defaultNodesAtom.debugLabel = "defaultNodesAtom";
